import { SyncModel, SyncDataModel, DataModel } from "../../core/shared/models/syncModel";

// Requests
export class SOTLanguageSyncModel extends SyncModel {
  public hyp_cus_nr: number;
}

/** Only one language exists and it has the id=0 (this const is used for selecting the language) */
export const SOTLanguageDMKey: number = 0;

// Responses
export class SOTLanguageDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; } // only SOTLanguageDMKey
  public id: number; // only SOTLanguageDMKey
  public languages: {key: string, value: {key: string, value: string}}; // {de: {key1: 'val1', key2: 'val2'}, en: {...}}
}

export class SOTLanguageSyncDataModel extends SyncDataModel {
  public languages: SOTLanguageDataModel[];
  public get models(): DataModel[] { return this.languages; }
  public DeserializeType(): void {
    this._DeserializeType(SOTLanguageDataModel);
  }
}
